import React, { useState } from 'react'
import { dateCol, intCol, numCol } from '@integec/grid-tools/lib/cols'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import {
  deleteNyisoMarsReportParameter,
  upsertNyisoMarsReportParameter,
  getNyisoMarsReportParameter,
} from 'api/pgads.js'

import { Button, DatePicker, InputNumber } from 'antd'
import { Label } from 'core/screen-util'
import CommonScreen from 'admin/component/CommonScreen'
import moment from 'moment'

const headers = [
  dateCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    isKey: true,
    width: 150,
  }),
  intCol({
    ident: 'minGapMinutes',
    display: 'Min Gap Minutes',
    isFiltered: true,
    isRequired: true,
    width: 150,
  }),
  numCol({
    ident: 'ignoreACPercent',
    display: 'Ignore AC %',
    isFiltered: true,
    isRequired: true,
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]

const title = 'MARS Report Parameters'

const NyisoMarsParameter = _ => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '100px 150px 150px 150px 120px 150px auto',
          gap: '5px',
        }}
      >
        <Label>Effective Date :</Label>
        <DatePicker
          className="effectiveDate"
          style={{ width: '100%' }}
          value={
            insertData.effectiveDateMom || moment(insertData.effectiveDate)
          }
          format="MM/DD/YYYY"
          onChange={date =>
            setInsertData({
              ...insertData,
              effectiveDate: date.format('YYYY-MM-DD'),
              effectiveDateMom: date,
            })
          }
          allowClear={false}
          placeholder="Effective Date"
        />
        <Label>Min Gap Minutes :</Label>
        <InputNumber
          placeholder="Min Gap Minutes"
          value={insertData.minGapMinutes}
          onChange={value =>
            setInsertData({ ...insertData, minGapMinutes: value })
          }
          style={{ width: '100%' }}
        />
        <Label>Ignore AC % :</Label>
        <InputNumber
          placeholder="Ignore AC %"
          value={insertData.ignoreACPercent}
          onChange={value =>
            setInsertData({ ...insertData, ignoreACPercent: value })
          }
          style={{ width: '100%' }}
        />
        <div
          style={{
            gap: 5,
            width: '300px',
            gridTemplateColumns: '1fr 1fr 1fr',
            display: 'grid',
          }}
        >
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>
          <Button type="primary" onClick={() => onAdd(false)}>
            Add & Hide
          </Button>
          <Button type="danger" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  return (
    <CommonScreen
      title={title}
      header={headers}
      saveTask={upsertNyisoMarsReportParameter}
      retrieveTask={getNyisoMarsReportParameter}
      deleteTask={deleteNyisoMarsReportParameter}
      altBy={d => d.effectiveDate}
      autoRetrieve
      // sortOptions={[{ ident: 'stationName', display: 'Station Name', sortOrder: 'asc' }]}
      widthOffset={400}
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      defaultInsertData={{
        effectiveDate: moment().format('YYYY-MM-DD'),
        effectiveDateMom: moment(),
      }}
    />
  )
}

// const mapStateToProps = state => ({
//   apiTargetInfo: getApiTargetInfo(state),
//   envConfig: getEnvConfig(state),
//   actionPermits: getPermitActions(state),
// })

// const mapDispatchToMap = dispatch => ({
//   saveStationMap: stations => dispatch({ type: STATIONS, payload: stations }),
//   // saveStation
// })

export default NyisoMarsParameter
